import React from 'react'
import ReactDOM from 'react-dom/client'
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import MiTheme from "./components/Theme/MiTheme";
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import ErrorPage from "./error-page";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import Root, { loader as loginLoader } from "./roots/root";
// import RootRedirect from "./roots/root-redirect";
// import RegisterRoot from "./roots/register-root";
// import CheckinRoot, { loader as checkinLoader } from "./roots/checkin-root";
// import Registration from "./covid/Registration";
// import ConfirmAccount from "./covid/Registration/ConfirmAccount";
// import ResetAccount from "./covid/Registration/ResetAccount";
// import QRLanding from "./covid/QRLanding";
// import InformedForm from "./intake_form";
// import WorksiteQrCode from "./covid/Worksite/WorksiteQrCode";
// import TransparencyComplianceFiles from "./recon/TransparencyComplianceFiles";
// import { loader as covidLoader } from "./covid/covid-home";
// import { loader as setupLoader } from "./my_members/covid/Setup/setup-home";
// import VaccinationHome from "./covid/Vaccination/vaccination-home";
// import VaccinationPage from "./covid/Vaccination";
// import Faqs from "./Faqs";
// import PrivacyPolicy from "./PrivacyPolicy";
// import AdminCovid, { loader as adminCovidLoader } from "./my_members/covid/admin-covid";
// import MyAccount, { loader as myAccountLoader } from "./MyAccount";
// import ReconMyAccount from "./recon/MyAccount"
// import CovidSetup from "./my_members/covid/Setup";
// import WelcomeAdmin from "./my_members/covid/WelcomeAdmin";
// import AdminCovidSetup from "./my_members/covid/admin-covid-setup";
// import DashboardMain from "./my_members/covid/dashboard-main";
// import DepartmentsMain from "./my_members/covid/departments-main";
// import EmployeesMain from "./my_members/covid/employees-main";
// import ExposuresMain, { loader as exposuresLoader } from "./my_members/covid/exposures-main";
// import WorksitesMain from "./my_members/covid/worksites-main";
// import VaccinationsMain from "./my_members/covid/vaccinations-main";
// import MyAccountMain from "./my_members/covid/my-account-main";
// import TokenReact from "./home/TokenReact";
// import { loader as reconHomeLoader } from "./recon/recon-home";
// import ReconClaimsInKp from "./recon/recon-claims-in-kp";
// import ReconProcudureDetailsInKp from "./recon/recon-procedure-details-in-kp";
// import ReconParent, { loader as reconLoader } from "./recon/recon-parent";
// import AdminParent, { loader as adminLoader } from "./my_members/admin-parent";
// import BenefitInfoPage, { loader as benefitInfoLoader } from "./recon/BenefitInfo/BenefitInfoPage";
// import HistoryPage from "./recon/ReconClaim/ReconHistory/HistoryPage";
// import BenefitModulesPage from "./recon/BenefitModules/benefit-modules-page";
// import QualifiedPerson from "./recon/QualifiedPerson";
// import ShopHealthcareMain, { loader as shopHealthcareLoader } from "./recon/ProviderSearch/shop-healthcare-main";
// import ShopHealthcareResultsMain from "./recon/ProviderSearch/shop-healthcare-results-main";
// import ProviderSearchMain, { loader as providerSearchLoader } from "./recon/ProviderSearch/provider-search-main";
// import ProviderSearchResultsMain from "./recon/ProviderSearch/provider-search-results-main";
// import ReconClaimsMain from "./recon/recon-claims-main";
// import SubproductMain from "./products/subproduct/subproduct-main";
// import ContactUs from "./ContactUs";
// import AdminOverview from "./my_members/admin-overview";
// import MemberParticipation from "./my_members/MemberSearch/member-participation";
// import HepBMain from "./my_members/help_b_program/hep-b-main";
// import { DescriptiveHighlights } from "./my_members/AdminActivity/DescriptiveHighlights";
// import { DescriptiveHighlightsDemo } from "./my_members/AdminActivity/DescriptiveHighlightsDemo";
// import { MbDashboards } from "./my_members/AdminActivity/MbDashboards";
// import GroundAmbulance from "./my_members/ground_ambulance"
// import { AdminRequest } from "./my_members/MemberSearch/AdminRequest";
// import EombDashboardMain from "./my_members/Eomb/dashboard-main";
// import CasesMain from "./my_members/Eomb/cases-main";
// import EombInvestigations from "./my_members/EombInvestigations";
// import EobProvider from "./my_members/Eomb/eob-provider";
// import EombProviderDetails from "./my_members/eomb-provider-details";
// import TrendDashboardMain from "./my_members/Eomb/trend-board-main";
// import AdminSummary from "./my_members/MemberSearch/admin-summary";
// import MiActivityMain from "./my_members/MemberSearch/mi-activity-main";
// import AdminNavigation from "./my_members/MemberSearch/admin-navigation";
// import AdminUtilization from "./my_members/MemberSearch/admin-utilization";
// import Overall from "./my_members/AdminActivity/Overall";
// import Recent from "./my_members/AdminActivity/Recent";
// import AddResults from "./my_members/MemberSearch/add-results";
// import ViewResults from "./my_members/MemberSearch/view-results";
// import ViewIncentives from "./my_members/MemberSearch/view-incentives";
// import TextNotifications from "./covid/Notification/TextNotifications";

// Lazy Load Components (export default Component)
const lazyDefaultExport = (importFn) => async () => {
    const module = await importFn();
    return { Component: module.default }
}

// Lazy Load Components (export Component)
const lazyExport = (importFn, componentName) => async () => {
    const module = await importFn();
    return { Component: module[componentName] }
}

// Lazy Load loaders
const lazyLoader = async ({ request, params }, importFn) => {
    let { loader } = await importFn();
    return loader({ request, params });
}

const router = createBrowserRouter([
    {
        path: "/",
        loader: ({ request, params }) => lazyLoader({ request, params }, () => import("./roots/root")),
        lazy: lazyDefaultExport(() => import("./roots/root")),
        shouldRevalidate: false,
        errorElement: <ErrorPage/>,
        id: 'root',
        children: [
            {
                index: true,
                lazy: lazyDefaultExport(() => import("./roots/root-redirect")),
            },
            // recon home
            {
                path: "recon_home",
                loader: ({ request, params }) => lazyLoader({ request, params }, () => import("./recon/recon-home")),
                // loader: reconHomeLoader,
            },
            {
                path: "recon_claims_in_kp",
                lazy: lazyDefaultExport(() => import("./recon/recon-claims-in-kp")),
                // element: <ReconClaimsInKp/>
            },
            {
                path: "recon_procedure_details_in_kp",
                lazy: lazyDefaultExport(() => import("./recon/recon-procedure-details-in-kp")),
                // element: <ReconProcudureDetailsInKp/>
            },
            {
                path: "recon",
                loader: ({ request, params }) => lazyLoader({ request, params }, () => import("./recon/recon-parent")),
                lazy: lazyDefaultExport(() => import("./recon/recon-parent")),
                id: 'recon',
                children: [
                    {
                        path: "benefit_info",
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./recon/BenefitInfo/BenefitInfoPage")),
                        lazy: lazyDefaultExport(() => import("./recon/BenefitInfo/BenefitInfoPage")),
                    },
                    {
                        path: "shop_healthcare",
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./recon/ProviderSearch/shop-healthcare-main")),
                        lazy: lazyDefaultExport(() => import("./recon/ProviderSearch/shop-healthcare-main")),
                    },
                    {
                        path: "shop_healthcare_results",
                        lazy: lazyDefaultExport(() => import("./recon/ProviderSearch/shop-healthcare-results-main")),
                    },
                    {
                        path: "claims",
                        lazy: lazyDefaultExport(() => import("./recon/recon-claims-root")),
                        // element: <ReconClaimsMain showRecent={'1'}/>
                    },
                    {
                        path: "history",
                        lazy: lazyDefaultExport(() => import("./recon/ReconClaim/ReconHistory/HistoryPage")),
                    },
                    {
                        path: "provider_preview",
                        lazy: lazyDefaultExport(() => import("./recon/recon-claims-root")),
                        // element: <ReconClaimsMain showRecent={'1'}/>
                    },
                    {
                        path: "add_qualified_person",
                        lazy: lazyDefaultExport(() => import("./recon/QualifiedPerson")),
                    },
                    {
                        path: "provider_search",
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./recon/ProviderSearch/provider-search-main")),
                        lazy: lazyDefaultExport(() => import("./recon/ProviderSearch/provider-search-main")),
                    },
                    {
                        path: "provider_search_results",
                        lazy: lazyDefaultExport(() => import("./recon/ProviderSearch/provider-search-results-main")),
                    },
                    {
                        path: "modules",
                        lazy: lazyDefaultExport(() => import("./recon/BenefitModules/benefit-modules-page")),
                    },
                    {
                        path: "labwork",
                        lazy: lazyDefaultExport(() => import("./recon/Results/lab-work-page")),
                    },
                    {
                        path: "organizations/:organizationId/service_groups/:serviceGroupId/subproduct/:subproductId/start",
                        lazy: lazyDefaultExport(() => import("./products/subproduct/subproduct-main")),
                        // element: <SubproductMain/>
                    },
                    {
                        path: 'my_account',
                        // loader: myAccountLoader,
                        // element: <ReconMyAccount/>
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./MyAccount")),
                        lazy: lazyDefaultExport(() => import("./recon/MyAccount")),
                    },
                    {
                        path: 'faqs',
                        lazy: lazyDefaultExport(() => import("./recon/faqs-main")),
                        // element: <Faqs productCategoryId={12}/>,
                    },
                    {
                        path: 'contact_us',
                        lazy: lazyDefaultExport(() => import("./ContactUs")),
                        // element: <ContactUs/>
                    },
                    {
                        path: 'privacy_policy',
                        lazy: lazyDefaultExport(() => import("./recon/privacy-policy-main")),
                        // element: <PrivacyPolicy lookupUrl={'privacy'}/>
                    },
                    {
                        path: 'terms_and_conditions',
                        lazy: lazyDefaultExport(() => import("./recon/terms-and-conditions-main")),
                        // element: <PrivacyPolicy lookupUrl={'user_agreement'}/>
                    }
                ]
            },
            // admin pages
            {
                path: 'eomb_investigations',
                lazy: lazyDefaultExport(() => import("./my_members/EombInvestigations")),
            },
            {
                path: 'eomb_provider_details',
                lazy: lazyDefaultExport(() => import("./my_members/eomb-provider-details")),
                // element: <EombProviderDetails/>
            },
            {
                path: 'admin',
                loader: ({ request, params }) => lazyLoader({
                    request,
                    params
                }, () => import("./my_members/admin-parent")),
                lazy: lazyDefaultExport(() => import("./my_members/admin-parent")),
                // loader: adminLoader,
                // element: <AdminParent/>,
                id: 'admin',
                children: [
                    {
                        path: "overview",
                        lazy: lazyDefaultExport(() => import("./my_members/admin-overview")),
                        // element: <AdminOverview/>
                    },
                    {
                        path: "member_participation",
                        children: [
                            {
                                index: true,
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/member-participation")),
                                // element: <MemberParticipation/>
                            },
                            {
                                path: "utilization",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/admin-utilization")),
                                // element: <AdminUtilization/>
                            },
                            {
                                path: "navigation",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/admin-navigation")),
                                // element: <AdminNavigation/>
                            },
                            {
                                path: "summary",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/admin-summary")),
                                // element: <AdminSummary/>
                            },
                            {
                                path: "mi_activity",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/mi-activity-main")),
                                // element: <MiActivityMain/>
                            },
                            {
                                path: "add_request",
                                lazy: lazyExport(() => import("./my_members/MemberSearch/AdminRequest"), 'AdminRequest'),
                                // element: <AdminRequest/>
                            },
                            {
                                path: "shop",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/shop")),
                                // element: <ShopHealthcareMain admin={true}/>
                            },
                            {
                                path: "shop_results",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/shop-results")),
                                // element: <ShopHealthcareResultsMain admin={true}/>
                            },
                            {
                                path: "provider_results",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/provider-search-results")),
                                // element: <ShopHealthcareResultsMain admin={true}/>
                            },
                            {
                                path: "active",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/recon-claims")),
                                // element: <ReconClaimsMain showRecent={'1'} readonly={true}/>
                            },
                            {
                                path: "hep_b",
                                lazy: lazyDefaultExport(() => import("./my_members/help_b_program/hep-b-main")),
                                // element: <HepBMain/>
                            },
                            {
                                path: "view_results",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/view-results")),
                                // element: <ViewResults/>
                            },
                            {
                                path: "add_results",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/add-results")),
                                // element: <AddResults/>
                            },
                            {
                                path: "view_incentives",
                                lazy: lazyDefaultExport(() => import("./my_members/MemberSearch/view-incentives")),
                                // element: <ViewIncentives/>
                            },
                        ]
                    },
                    {
                        path: "admin_eomb",
                        children: [
                            {
                                path: "dashboard",
                                lazy: lazyDefaultExport(() => import("./my_members/Eomb/eomb-dashboard-main")),
                                // element: <EombDashboardMain isDemo={false}/>
                            },
                            {
                                path: "dashboard_demo",
                                lazy: lazyDefaultExport(() => import("./my_members/Eomb/eomb-dashboard-demo-main")),
                                // element: <EombDashboardMain isDemo={true}/>
                            },
                            {
                                path: "trend_board",
                                lazy: lazyDefaultExport(() => import("./my_members/Eomb/trend-board-main")),
                                // element: <TrendDashboardMain/>
                            },
                            {
                                path: "provider",
                                lazy: lazyDefaultExport(() => import("./my_members/Eomb/eob-provider")),
                                // element: <EobProvider/>
                            },
                            {
                                path: "cases",
                                lazy: lazyDefaultExport(() => import("./my_members/Eomb/cases-main")),
                                // element: <CasesMain/>
                            },
                            { path: "provider_demo", element: <div>provider_demo</div> },
                            { path: "trend_board_demo", element: <div>trend_board_demo</div> },
                        ],
                    },
                    {
                        path: "admin_activity",
                        children: [
                            {
                                path: "overall",
                                lazy: lazyDefaultExport(() => import("./my_members/AdminActivity/Overall")),
                                // element: <Overall/>
                            },
                            {
                                path: "recent",
                                lazy: lazyDefaultExport(() => import("./my_members/AdminActivity/Recent")),
                                // element: <Recent/>
                            },
                            {
                                path: "descriptive_highlights",
                                lazy: lazyDefaultExport(() => import("./my_members/AdminActivity/descriptive-highlights-main")),
                                // element: <DescriptiveHighlights dashboardId={'engagement'}/>
                            },
                            {
                                path: "descriptive_highlights_demo",
                                lazy: lazyDefaultExport(() => import("./my_members/AdminActivity/descriptive-highlights-demo-main")),
                                // element: <DescriptiveHighlightsDemo dashboardId={'engagement'}/>
                            },
                            {
                                path: "mb_dashboards",
                                lazy: lazyExport(() => import("./my_members/AdminActivity/MbDashboards"), 'MbDashboards'),
                                // element: <MbDashboards/>
                            },
                        ],
                    },
                    {
                        path: "admin_oversight",
                        children: [
                            {
                                path: "superutilizers",
                                lazy: lazyExport(() => import("./my_members/AdminActivity/MbDashboards"), 'MbDashboards'),
                                // element: <MbDashboards/>
                            },
                            {
                                path: "trend",
                                lazy: lazyExport(() => import("./my_members/AdminActivity/MbDashboards"), 'MbDashboards'),
                                // element: <MbDashboards/>
                            }
                        ],
                    },
                    {
                        path: "admin_nsa",
                        children: [
                            {
                                path: "coc",
                                lazy: lazyExport(() => import("./my_members/AdminActivity/MbDashboards"), 'MbDashboards'),
                                // element: <MbDashboards/>
                            },
                            {
                                path: "ground_ambulance",
                                lazy: lazyDefaultExport(() => import("./my_members/ground_ambulance")),
                                // element: <GroundAmbulance/>
                            },
                            {
                                path: "mb_dashboards",
                                lazy: lazyExport(() => import("./my_members/AdminActivity/MbDashboards"), 'MbDashboards'),
                                // element: <MbDashboards/>
                            },
                            {
                                path: "paper_claims", // <-- your new URL segment
                                lazy: lazyDefaultExport(() => import("./my_members/Eomb/paper-claims-main")),
                            },
                        ],
                    }
                ]
            },
            // token page
            {
                path: "token",
                lazy: lazyDefaultExport(() => import("./home/TokenReact")),
                // element: <TokenReact/>,
            },
            // covid pages
            {
                path: 'covid_home',
                loader: ({ request, params }) => lazyLoader({
                    request,
                    params
                }, () => import("./covid/covid-home")),
                // loader: covidLoader,
            },
            {
                path: 'vaccination',
                lazy: lazyDefaultExport(() => import("./covid/Vaccination/vaccination-home")),
                // element: <VaccinationHome/>,
                children: [
                    {
                        path: 'employee',
                        lazy: lazyDefaultExport(() => import("./covid/Vaccination/vaccination-page-main")),
                        // element: <VaccinationPage isEmployee={true}/>
                    },
                    {
                        path: 'faqs',
                        lazy: lazyDefaultExport(() => import("./Faqs")),
                        // element: <Faqs/>
                    },
                    {
                        path: 'privacy_policy',
                        lazy: lazyDefaultExport(() => import("./covid/Vaccination/privacy-policy-main")),
                        // element: <PrivacyPolicy lookupUrl={'privacy'}/>
                    },
                    {
                        path: 'terms_and_conditions',
                        lazy: lazyDefaultExport(() => import("./covid/Vaccination/terms-and-conditions-main")),
                        // element: <PrivacyPolicy lookupUrl={'user_agreement'}/>
                    }
                ]
            },
            {
                path: 'admin_covid',
                loader: ({ request, params }) => lazyLoader({
                    request,
                    params
                }, () => import("./my_members/covid/admin-covid")),
                lazy: lazyDefaultExport(() => import("./my_members/covid/admin-covid")),
                // loader: adminCovidLoader,
                // element: <AdminCovid/>,
                id: 'admin_covid',
                children: [
                    {
                        path: 'covid_my_account',
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./MyAccount")),
                        lazy: lazyDefaultExport(() => import("./MyAccount")),
                        // loader: myAccountLoader,
                        // element: <MyAccount/>,
                    },
                    {
                        path: 'faqs',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/faqs-main")),
                        // element: <Faqs productCategoryId={12}/>,
                    },
                    {
                        path: 'privacy_policy',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/privacy-policy-main")),
                        // element: <PrivacyPolicy lookupUrl={'privacy'}/>,
                    },
                    {
                        path: 'terms_and_conditions',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/terms-and-conditions-main")),
                        // element: <PrivacyPolicy lookupUrl={'user_agreement'}/>,
                    },
                    {
                        path: 'setup',
                        // loader: setupLoader,
                        // element: <AdminCovidSetup/>,
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./my_members/covid/Setup/setup-home")),
                        lazy: lazyDefaultExport(() => import("./my_members/covid/admin-covid-setup")),
                        children: [
                            {
                                path: ':step',
                                lazy: lazyDefaultExport(() => import("./my_members/covid/Setup")),
                                // element: <CovidSetup/>
                            },
                            {
                                path: 'welcome',
                                lazy: lazyDefaultExport(() => import("./my_members/covid/WelcomeAdmin")),
                                // element: <WelcomeAdmin/>
                            }
                        ]
                    },
                    {
                        path: 'dashboard',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/dashboard-main")),
                        // element: <DashboardMain/>
                    },
                    {
                        path: 'departments',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/departments-main")),
                        // element: <DepartmentsMain/>
                    },
                    {
                        path: 'employees',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/employees-main")),
                        // element: <EmployeesMain/>
                    },
                    {
                        path: 'exposures',
                        loader: ({ request, params }) => lazyLoader({
                            request,
                            params
                        }, () => import("./my_members/covid/exposures-main")),
                        lazy: lazyDefaultExport(() => import("./my_members/covid/exposures-main")),
                        // loader: exposuresLoader,
                        // element: <ExposuresMain/>
                    },
                    {
                        path: 'my_account',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/my-account-main")),
                        // element: <MyAccountMain/>
                    },
                    {
                        path: 'vaccinations',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/vaccinations-main")),
                        // element: <VaccinationsMain/>
                    },
                    {
                        path: 'worksites',
                        lazy: lazyDefaultExport(() => import("./my_members/covid/worksites-main")),
                        // element: <WorksitesMain/>
                    },
                ]
            }
        ]
    },
    {
        path: "checkin",
        // element: <CheckinRoot/>,
        loader: ({ request, params }) => lazyLoader({ request, params }, () => import("./roots/checkin-root")),
        lazy: lazyDefaultExport(() => import("./roots/checkin-root")),
        // loader: checkinLoader,
        errorElement: <ErrorPage/>,
        id: "checkin-root",
        children: [
            {
                path: ":uuid",
                lazy: lazyDefaultExport(() => import("./covid/QRLanding")),
                // element: <QRLanding/>
            }
        ]
    },
    {
        path: 'ExP',
        // element: <CheckinRoot/>,
        lazy: lazyDefaultExport(() => import("./roots/checkin-root")),
        errorElement: <ErrorPage/>,
        children: [
            {
                path: ":uuid",
                lazy: lazyDefaultExport(() => import("./covid/Notification/TextNotifications")),
                // element: <TextNotifications/>
            }
        ]
    },
    {
        path: "generate_qr_code",
        // element: <CheckinRoot/>,
        lazy: lazyDefaultExport(() => import("./roots/checkin-root")),
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                // element: <WorksiteQrCode/>
                lazy: lazyDefaultExport(() => import("./covid/Worksite/WorksiteQrCode")),
            }
        ]
    },
    {
        path: "informed",
        // element: <CheckinRoot/>,
        lazy: lazyDefaultExport(() => import("./roots/checkin-root")),
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                // element: <InformedForm/>
                lazy: lazyDefaultExport(() => import("./intake_form")),
            }
        ]
    },
    {
        path: "mrf",
        // element: <CheckinRoot/>,
        lazy: lazyDefaultExport(() => import("./roots/checkin-root")),
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                // element: <TransparencyComplianceFiles/>
                lazy: lazyDefaultExport(() => import("./recon/TransparencyComplianceFiles")),
            }
        ]
    },
    {
        path: "register",
        // element: <RegisterRoot/>,
        lazy: lazyDefaultExport(() => import("./roots/register-root")),
        errorElement: <ErrorPage/>,
        children: [
            {
                path: "create_account",
                lazy: lazyDefaultExport(() => import("./covid/Registration")),
                // element: <Registration/>
            },
            {
                path: "confirm_account/:id",
                lazy: lazyDefaultExport(() => import("./covid/Registration/ConfirmAccount")),
                // element: <ConfirmAccount/>
            },
            {
                path: "reset_account/:id",
                lazy: lazyDefaultExport(() => import("./covid/Registration/ResetAccount")),
                // element: <ResetAccount/>
            }
        ]
    }
]);


ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={MiTheme}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <RouterProvider router={router}/>
                </LocalizationProvider>
            </MuiThemeProvider>
        </StyledEngineProvider>
    </React.StrictMode>,
)
